import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { LayoutViewModel } from '@/modules/recognition/presentation/screens/AccountManagement/Layout.vm';
import { Props, SideMenu } from '@/shared/presentation/components/SideMenu';

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const Layout: React.FC = observer(() => {
  const navigate = useNavigate();
  const vm = useViewModel(LayoutViewModel, { navigate });

  const menuItems = useMemo(
    () =>
      [
        {
          label: 'Dados pessoais',
          icon: Icons.account(),
          path: '/account',
          isExactPath: true,
        },
        {
          label: 'Alterar senha',
          icon: Icons.password(),
          path: '/account/password',
          isExactPath: true,
        },
        {
          label: 'Sair',
          path: '/logout',
          icon: Icons.logout(),
          onClick: () => vm.logout(),
        },
      ] as Props['menuItems'],
    [],
  );

  return (
    <Content>
      <SideMenu menuItems={menuItems} />
      <Outlet />
    </Content>
  );
});

const Icons = {
  account: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" />
    </svg>
  ),

  password: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
    </svg>
  ),

  logout: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" />
    </svg>
  ),
};
